import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxId,
    orgName,
    taxId2,
    address,
    contract,
    contractNumber,
    contractNumberDate,
    orgName2,
    address2,
    taxId3,
    taxId4,
    checkbox1,
    checkbox2,
    taxId5,
    orgName3,
    taxId6,
    address3,
    contract2,
    moneyType,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [contract.name]: Yup.string().optional(),
  [checkbox1.name]: Yup.string().optional(),
  [checkbox2.name]: Yup.string().optional(),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [contractNumber.name]: Yup.string().required(contractNumber.errorMsg),
  [contractNumberDate.name]: Yup.string().required(contractNumberDate.errorMsg),
  [orgName2.name]: Yup.string().required(orgName2.errorMsg),
  [orgName3.name]: Yup.string().required(orgName3.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [address3.name]: Yup.string().required(address3.errorMsg),
  [contract2.name]: Yup.string().required(contract2.errorMsg),

  [orgName.name]: Yup.string().required(orgName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [moneyType.name]: Yup.string().required(moneyType.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxId3.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId3.invalidMsg)
    .required(taxId3.errorMsg),
  [taxId4.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId4.invalidMsg)
    .required(taxId4.errorMsg),
  [taxId5.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId5.invalidMsg)
    .required(taxId5.errorMsg),
  [taxId6.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId6.invalidMsg)
    .required(taxId6.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
